import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admincallcenter',
  templateUrl: './admincallcenter.component.html',
  styleUrls: ['./admincallcenter.component.css']
})
export class AdmincallcenterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
